import React from 'react';
import '../../App.css';
import Contact from '../Contact';
import Footer from '../Footer';

function ContactPage() {
    return (
        <>
          <Contact />
          <Footer />
        </>
      );
}

export default ContactPage;
